declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';

import * as alertFunctions from '../../../../shared/data/sweet-alerts';


declare var require: any;

import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
//import { NgbAddBill } from '../modal/addbill.modal';
//import { NgbPayBillModal } from './paybill.modal';
import { PatientInfoByFormattedCodeController, ServicesByCategoryCodeController, ServicesByCategoryCodeRequest, NewBillData, SaveBillItemsInfoRequest, OrderData, SaveiahOrderRequest, ConsumptionGroupItemsController, ConsumptionGroupItemsRequest, StoreLocationMaterialsController, StoreLocationMaterialsRequest, MaterialBatchInaStoreController, SaveMaterialConsumptionEntriesRequest, FinalizeConsumptionEntryRequest, AdmissionsByCodeController, AdmissionsByCodeRequest, AdmissionDetailsInfoController, AdmissionsListController, DoctorsListController, DoctorsListRequest, GenericProcPostRequest, GenericParams, FTV, S_Methods, SaveDischargeDetails, DischargeDetailsController, AdmissionsHeader2, SaveAdmissionDetailsRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { PatientInfoByFormattedCodeRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { Servicebillpipe, Storelistpipe } from '../../../pipes/actors/actorIdentity.pipes';
import { NgbAddBill } from '../opbilling/modal/addbill.modal';
import { NgbPayBillModal } from '../opbilling/paybill.modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbSearchProviderModal } from '../ivf/ivfworkbench/searchprovider.modal';
//import { NgbPaymentModal } from './modal/payment.modal';





@Component({
  selector: 'editadmission',
  templateUrl: './editadmission.component.html',
  styleUrls: ['./editadmission.component.scss']
  , animations: [routerTransition()]
})

export class EditAdmissionComponent implements OnInit {

  public Admission: AdmissionsListController;
  public ApiResData: ApiResponseModel;
  @Input() FormattedCode: string;

  // public ActorCode: number = 0;
  //public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  // public Consumptioncode: number;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public activeTab: string = 'admissiondetails';
  public ShowList: boolean = true;
  public EditList: boolean = false;
  public Tabslist: boolean = true;
  public Insurancetoggle: boolean = false;
  public PrimaryDoctorO: boolean = true;
  public PrimaryDoctorn: boolean = false;
  public PrimaryDoctor: string;
  public PrimaryCode: number;
  public PrimaryNumber: number;
  public ShowPatientDetails: boolean = false;
  public receipt: boolean = true;
  public opbilling: boolean = false;
  public Add: boolean = true;
  public Edit: boolean = false;
  public isRequesting: boolean = false;
  public cash: boolean = false;
  public card: boolean = false;
  public cheque: boolean = false;
  public demanddraft: boolean = false;
  public paytm: boolean = false;
  public FormattedCodedata: any;
  public AdmissionCodedata: any;
  public FacilityCodedata: any;
  public Code: any;
  public TotalBill: number;
  public NetPayable: number;
  public BranchName: string;
  public FacilityCode: number;
  public ActorCode: number;
  public Date: Date;
  searchTitle: string;
  public DischargeDate: NgbDateStruct;
  TodayDate = new Date();
  public Remarks: string;

  CurrentAdmissionsByCodeController: AdmissionsByCodeController[];
  CurrentAdmissionsByCodeRequest: AdmissionsByCodeRequest;
  CurrentSaveAdmissionDetailsRequest: SaveAdmissionDetailsRequest;
  AdmissionData: AdmissionDetailsInfoController;
  AdmissionHeader2: AdmissionsHeader2;  //take from  101029
  SelectedAdmission: AdmissionsByCodeController;
  LoadAdmissionsDetails() {
    this.CurrentAdmissionsByCodeRequest = new AdmissionsByCodeRequest();
    this.CurrentAdmissionsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetAdmissionsByCodeController();
  }

  GetAdmissionsByCodeController() {
    this.StartRefreshing();
    this.CurrentAdmissionsByCodeRequest.ConditionalOperator = 10;
    //this.CurrentAdmissionsListRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentAdmissionsByCodeRequest.AdmissionCode = this.AdmissionCodedata;
    this.CurrentAdmissionsByCodeRequest.FacilityCode = this.FacilityCodedata;

    this.actorservice.GetAdmissionsByCodeController(this.CurrentAdmissionsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData?.hasError && this.ApiResData?.Result) {
          const res = this.ApiResData.Result;
          if (Array.isArray(res)) {
            this.CurrentAdmissionsByCodeController = res;
            this.SelectedAdmission = res.length > 0 ? res[0] : new AdmissionsByCodeController();
          } else if (res.AdmissionItems) {
            this.CurrentAdmissionsByCodeController = res.AdmissionItems;
            this.SelectedAdmission = res.AdmissionItems.length > 0 ? res.AdmissionItems[0] : new AdmissionsByCodeController();
          } else {
            this.CurrentAdmissionsByCodeController = [res];
            this.SelectedAdmission = res;
          }
          this.stopRefreshing();

          this.LoadDetailedAdmissionData();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
    LoadDetailedAdmissionData() {
      /// 101029
      var gReq: GenericProcPostRequest = new GenericProcPostRequest();
      var getReq: GenericParams = new GenericParams();
      getReq.ConditionalOperator = 101029;
      getReq.Params = [
        new FTV('AdmissionNo', 'number', this.AdmissionCodedata)        
      ];
      getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      var str = JSON.stringify(getReq);
      gReq.ConditionalOperator = 101029;
      gReq.QueryData = str;
      gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.actorservice.Save<GenericProcPostRequest>(
        gReq, S_Methods.GetGenericPost)
        .subscribe((result) => {

          this.ApiResData = result;
          if (!this.ApiResData?.hasError && this.ApiResData?.Result) {
            try {
              if (Array.isArray(this.ApiResData.Result) && this.ApiResData.Result.length > 0) {
                var data: string = this.ApiResData.Result.join("");
                if (data && data !== '[{}]') {
                  const parsed = JSON.parse(data);
                  if (Array.isArray(parsed) && parsed.length > 0) {
                    this.AdmissionHeader2 = parsed[0];
                  }
                }
              }
            } catch (e) {
              console.warn('Error parsing AdmissionHeader2', e);
            }
            this.stopRefreshing();
          }
          else {
            this.stopRefreshing();
            if (this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            }
            else {
              this.stopRefreshing();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }

        },
          (error) => {

            if (error == "401 - Unauthorized") {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
            else {
              alertFunctions.AlertParamEr(error);

              this.stopRefreshing();
            }
          }
        );
    }
  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCodedata;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData?.hasError && this.ApiResData?.Result) {
          const res = this.ApiResData.Result;
          this.CurrentPatientInfoByFormattedCodeController = Array.isArray(res) ? res : [res];
          if (this.CurrentPatientInfoByFormattedCodeController && this.CurrentPatientInfoByFormattedCodeController.length > 0) {
            this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          }
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private loaderService: SpinnerService,
    private modalService: NgbModal,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,
    private filter: Storelistpipe, private spinner: NgxSpinnerService


  ) { }
  public SelectedAdmissionString: any;
  ngOnInit() {
    this.AdmissionCodedata = this.route.snapshot.paramMap.get('AdmissionCodedata');
    this.FormattedCodedata = this.route.snapshot.paramMap.get('FormattedCodedata');
    this.FacilityCodedata = this.route.snapshot.paramMap.get('FacilityCodedata');
    //alert(this.route.snapshot.paramMap.get('SelectedAdmissionString'));
    //this.Admission = JSON.parse(this.route.snapshot.paramMap.get('SelectedAdmissionString'));
    //alert('Admitted Patient: ' + this.Admission.PatientName);
    //this.AdmissionCodedata = this.Admission.AdmissionCode;//.this.route.snapshot.paramMap.get('AdmissionCodedata');
    //this.FormattedCodedata = this.Admission.PatientFormattedCode;//route.snapshot.paramMap.get('FormattedCodedata');
    //this.FacilityCodedata = this.Admission.FacilityCode;//route.snapshot.paramMap.get('FacilityCodedata');
    this.Code = this.route.snapshot.paramMap.get('Code');
    this.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.Date = new Date();
    this.BranchName = AppData.Instance().SelectedBranchName;
    this.LoadAdmissionsDetails();
    this.LoadPatients();
    this.LoadDoctorsList();
    this.LoadDischargeDetails();
    this.DischargeDate = {
      year: this.TodayDate.getUTCFullYear(),
      month: this.TodayDate.getUTCMonth() + 1,
      day: this.TodayDate.getDate()
    };
  }
  DischargeDetails: DischargeDetailsController[];
  LoadDischargeDetails() {
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var getReq: GenericParams = new GenericParams();
    getReq.ConditionalOperator = 101028;
    getReq.Params = [
      new FTV('AdmissionNo', 'number', this.AdmissionCodedata)
    ];
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101028;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData?.hasError && this.ApiResData?.Result) {
          try {
            if (Array.isArray(this.ApiResData.Result) && this.ApiResData.Result.length > 0) {
              var data: string = this.ApiResData.Result.join("");
              if (data && data !== '[{}]') {
                const parsed = JSON.parse(data);
                if (Array.isArray(parsed) && parsed.length > 0) {
                  this.DischargeDetails = parsed[0];
                }
              }
            }
            this.stopRefreshing();
          }
          catch (e) {
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }

  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentDoctorsListController = this.ApiResData.Result;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  public DischargingPhysicianName: string;
  public DischargingPhysician: number;

  public ApprovedByName: string;
  public ApprovedBy: number;
  onChange(Event: any) {
    if (Event != null && this.CurrentDoctorsListController.length > 0) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      if (a.length > 0) {
        this.DischargingPhysicianName = a[0].DisplayName;
        this.DischargingPhysician = a[0].ProviderCode;
      }
    }

  }
  onChange2(Event: any) {
    if (Event != null && this.CurrentDoctorsListController.length > 0) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      if (a.length > 0) {
        this.ApprovedByName = a[0].DisplayName;
        this.ApprovedBy = a[0].ProviderCode;
      }
    }

  }
  DischargeInitiation() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DischargeInitiation2();
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }

  DischargeInitiation2() {
    var saveReq = new SaveDischargeDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40192;
    saveReq.AdmissionNo = this.AdmissionCodedata;
    saveReq.DischargeInitiatedBy = this.SelectedEmployeeCode;
    saveReq.DischargeInitiatedUser = this.SelectedEmpName;
    saveReq.ActionTag = 'Initiation';
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40192;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.LoadAdmissionsDetails();
          this.LoadDischargeDetails();
          // then refresh
          //this.GetServiceProviders();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  DischargeApproval() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DischargeApproval2();
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DischargeApproval2() {
    var saveReq = new SaveDischargeDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40192;
    saveReq.AdmissionNo = this.AdmissionCodedata;
    saveReq.ApprovedBy = this.ApprovedBy;
    saveReq.ApprovedByName = this.ApprovedByName;
    saveReq.ActionTag = 'Approval';
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40192;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.LoadAdmissionsDetails();
          this.LoadDischargeDetails();
          // then refresh
          //this.GetServiceProviders();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  DischargeClosure() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DischargeClosureWithoutMedAdvice();
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DischargeClosureWithoutMedAdvice() {
    var saveReq = new SaveDischargeDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40192;
    saveReq.AdmissionNo = this.AdmissionCodedata;
    saveReq.DischargingPhysician = this.DischargingPhysician;
    saveReq.DischargingPhysicianName = this.DischargingPhysicianName;
    saveReq.DischargeDate = new Date(this.parserFormatter.format(this.DischargeDate));
    saveReq.Remarks = this.Remarks;
    saveReq.ActionTag = 'Closure';
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40192;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.LoadAdmissionsDetails();
          this.LoadDischargeDetails();
          // then refresh
          //this.GetServiceProviders();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  DischargeClosure2() {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, Proceed!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DischargeClosureWithMedAdvice();
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  public IsDiscAgainstMedAdvise: boolean;
  DischargeClosureWithMedAdvice() {
    var saveReq = new SaveDischargeDetails();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40192;
    saveReq.AdmissionNo = this.AdmissionCodedata;
    saveReq.DischargingPhysician = this.DischargingPhysician;
    saveReq.DischargingPhysicianName = this.DischargingPhysicianName;
    saveReq.DischargeDate = new Date(this.parserFormatter.format(this.DischargeDate));
    saveReq.Remarks = this.Remarks;
    saveReq.IsDiscAgainstMedAdvise = this.IsDiscAgainstMedAdvise;
    saveReq.ActionTag = 'Closure';
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40192;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.LoadAdmissionsDetails();
          this.LoadDischargeDetails();
          // then refresh
          //this.GetServiceProviders();
          //this.activeModal.close();
          //}
          //else {
          //alertFunctions.AlertParam("Invalid Operation...!");
          //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  SaveAdmissionDetails() {
    this.StartRefreshing();
    this.spinner.show();
    this.CurrentSaveAdmissionDetailsRequest = new SaveAdmissionDetailsRequest();
    this.CurrentSaveAdmissionDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentSaveAdmissionDetailsRequest.ConditionalOperator = 10;
    if (this.SelectedAdmission) {
      this.CurrentSaveAdmissionDetailsRequest.AdmissionCode = this.SelectedAdmission.AdmissionCode;
      this.CurrentSaveAdmissionDetailsRequest.PatientCode = this.SelectedAdmission.PatientCode;
      this.CurrentSaveAdmissionDetailsRequest.CareUnit = this.SelectedAdmission.CareUnit || '';
      this.CurrentSaveAdmissionDetailsRequest.BedLocation = this.SelectedAdmission.BedLocation || '';
      this.CurrentSaveAdmissionDetailsRequest.EstimatedStay = this.SelectedAdmission.EstimatedLengthOfStay ? this.SelectedAdmission.EstimatedLengthOfStay.toString() : '';
      this.CurrentSaveAdmissionDetailsRequest.ConsentFormNo = this.SelectedAdmission.ConsentFormNo || '';
      this.CurrentSaveAdmissionDetailsRequest.AdmissionStatus = this.SelectedAdmission.AdmissionStatus || 'ADMTD';
      this.CurrentSaveAdmissionDetailsRequest.AdmissionReason = this.SelectedAdmission.AdmissionReason || '';
      this.CurrentSaveAdmissionDetailsRequest.ProposedTreatment = this.SelectedAdmission.ProposedTreatment || '';
      this.CurrentSaveAdmissionDetailsRequest.ProposedTreatmentRemarks = this.SelectedAdmission.ProposedTreatmentRemarks || '';
    }
    this.CurrentSaveAdmissionDetailsRequest.FacilityCode = this.FacilityCode;
    this.CurrentSaveAdmissionDetailsRequest.LastModifiedUser = AppData.Instance().UserLoginDetails.ActorCode;

    this.actorservice.SaveAdmissionDetails(this.CurrentSaveAdmissionDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.Cancel();
          this.LoadAdmissionsDetails();
        } else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != '') {
            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          } else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }
      }, (error) => {
        this.stopRefreshing();
        this.spinner.hide();
        alertFunctions.AlertParamEr(error);
      });
  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  Editlist() {
    this.ShowList = false;
    this.EditList = true;
    this.Tabslist = true;
  }
  BackToAdmission() {
    this.router.navigate(['healins/admissions']);
  }
  toggle() {
    this.Insurancetoggle = true;
    this.ShowList = false;
    this.EditList = true;
    this.Tabslist = true;
  }
  SelectPrimaryDoctor() {
    this.PrimaryDoctorO = false;
    this.PrimaryDoctorn = true;
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.IsShowDoctor = true;
    modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.PrimaryDoctor = receivedEntry.make;
      this.PrimaryCode = receivedEntry.value;
      this.PrimaryNumber = receivedEntry.number;
      //this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
      //alert(this.ProviderName);
    })
  }
  pdata: any[];// = this.data;
  listFilter: string;

  Cancel() {
    this.ShowList = true;
    this.EditList = false;
    this.Tabslist = true;
  }
  SelectedEmpName: string;
  SelectedEmployeeCode: number;
  Roleassignemp(event: any) {
    if (event != null) {
      this.SelectedEmpName = event;
    }
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
}

